import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import Edit from "@mui/icons-material/Edit";
import ExploreIcon from "@mui/icons-material/Explore";
import FeedIcon from "@mui/icons-material/Feed";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import MoneyIcon from "@mui/icons-material/Money";
import MovieIcon from "@mui/icons-material/Movie";
import PhotoLibrary from "@mui/icons-material/PhotoLibrary";
import SubjectIcon from "@mui/icons-material/Subject";
import VideoLibrary from "@mui/icons-material/VideoLibrary";
import CenterContentsMenu from "./CenterContentsMenu";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { FlashOn } from "@mui/icons-material";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";

interface CenterContentsManagerProps {
  activeMenu: string;
}

const CenterContentsManager = ({ activeMenu }: CenterContentsManagerProps) => {
  const tenakAis = [
    {
      key: "browsing",
      path: "/chat",
      icon: <ChatBubbleIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.browsing",
    },
    {
      key: "text",
      path: "/writing-ai/article",
      icon: <SubjectIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.writingAI",
    },
    {
      key: "mind-map",
      path: "/mind-map",
      icon: <AccountTreeOutlinedIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.mindmapGenerator",
    },
    {
      key: "color-generator",
      path: "/color-generator",
      icon: <ColorLensIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.colorGenerator",
    },
    {
      key: "templates",
      path: "/template",
      icon: <MoneyIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.templates",
    },
  ];

  const tenakLibraries = [
    {
      key: "text",
      path: "/notes-nebula/files",
      icon: <SubjectIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.text",
    },
    {
      key: "mind-map",
      path: "/mind-map",
      icon: <AccountTreeOutlinedIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.mindmap",
    },
  ];

  const junoAis = [
    {
      key: "explore",
      path: "/juno",
      icon: <ExploreIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.explore",
    },
    {
      key: "imageGenerator",
      path: "/juno/image-generator",
      icon: <ImageOutlinedIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.imageGenerator",
    },
    {
      key: "videoGenerator",
      path: "/juno/video-generator",
      icon: <MovieIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.videoGenerator",
    },
    {
      key: "sounds",
      path: "/juno/sounds/music-generator",
      icon: <GraphicEqIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.musicGenerator",
    },
    {
      key: "voices",
      path: "/juno/sounds/voice-generator",
      icon: <KeyboardVoiceIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.voiceGenerator",
    },
    {
      key: "models",
      path: "/juno/models",
      icon: <FlashOn fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.models",
    },
  ];

  const junoLibraries = [
    {
      key: "images",
      path: "/juno/gallery",
      icon: <PhotoLibrary fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.myImages",
    },
    {
      key: "videos",
      path: "/juno/videos",
      icon: <VideoLibrary fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.myVideos",
    },
    {
      key: "voices",
      path: "/juno/sounds/voice-generator",
      icon: <GraphicEqIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.myVoices",
    },
  ];

  const notesAis = [
    {
      key: "articles",
      path: "/notes-nebula?tab=articles",
      icon: <FeedIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.articles",
    },
    {
      key: "textEditor",
      path: "",
      icon: <Edit fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.createText",
    },
    {
      key: "bookmark",
      path: "/notes-nebula?tab=bookmark",
      icon: <BookmarkIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.bookmark",
    },
  ];

  const notesLibraries = [
    {
      key: "text",
      path: "/notes-nebula/files",
      icon: <SubjectIcon fontSize={"small"} color={"primary"} sx={{ my: 1 }} />,
      label: "drawer.text",
    },
  ];

  const selectedAis = activeMenu === "" ? tenakAis : activeMenu === "juno" ? junoAis : notesAis;
  const selectedLibraries = activeMenu === "" ? tenakLibraries : activeMenu === "juno" ? junoLibraries : notesLibraries;

  return <CenterContentsMenu ais={selectedAis} libraries={selectedLibraries} activeMenu={activeMenu} />;
};
export default CenterContentsManager;
